<template>
    <section class="flex-container my-4">
        <div class="flex justify-between flex-wrap">
            <h4 class="font-semibold">Atendimento</h4>
            <span class="text-azul-info font-semibold">Nº {{ protocolo }}</span>
        </div>
        <div class="flex justify-between flex-wrap">
            <div class="flex items-center">
                <Icone :nome="'calendar_month'" />
                <span class="">{{ dataAtendimento }} {{ horaAtendimento }}</span>
            </div>

            <div v-if="dataAgendamento || horaAgendamento" class="flex items-center">
                <Icone :nome="'calendar_clock'" />
                <span class="">{{ dataAgendamento }} {{ horaAgendamento }}</span>
            </div>
        </div>
        <div class="flex items-center">
            <Icone :nome="'build'" />
            <span>{{ nomeServico }}</span>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import Icone from '@/components/Icone.vue';

export default defineComponent({
    name: 'InfoAtendimento',
    components: {
        Icone
    },
    props: {
        protocolo: {
            type: String,
            required: true
        },
        dataAtendimento: {
            type: String,
            required: true
        },
        horaAtendimento: {
            type: String,
            required: true
        },
        dataAgendamento: {
            type: String,
        },
        horaAgendamento: {
            type: String,
        },
        nomeServico: {
            type: String,
            required: true
        }
    }
});
</script>